import { initializeApp } from 'firebase/app';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import type { Functions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import type { Auth } from 'firebase/auth';
import { getRemoteConfig } from 'firebase/remote-config';
import type { RemoteConfig } from 'firebase/remote-config';
import { getFirestore, connectFirestoreEmulator, Firestore } from 'firebase/firestore';
import { getAnalytics, logEvent } from 'firebase/analytics';
import type { Analytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

export const auth: Auth = getAuth(app);
export const functions: Functions = getFunctions(app, 'europe-west1');
export const remoteConfig: RemoteConfig = getRemoteConfig(app);
export const db: Firestore = getFirestore(app);

// Initialize Analytics only in production environment
let analytics: Analytics | null = null;
if (typeof window !== 'undefined' && import.meta.env.PROD) {
    analytics = getAnalytics(app);
}

export { analytics, logEvent };


// 👇 Connetti al simulatore solo in sviluppo!
if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true") {
    //connectAuthEmulator(auth, "http://localhost:9099");
    connectFunctionsEmulator(functions, "localhost", 5001);
    connectFirestoreEmulator(db, "localhost", 8080);
    // Remote Config non ha un emulatore, quindi si usa quello di produzione.
}